
// 车牌照
// 31 个省和直辖市或 "警" 开头
// 英文+数字 6-7 位
// 最后一位支持 "挂"，可有可无
export class GC_Valid_T_Plate {

    protected regex = '^[\\u65b0\\u85cf\\u7518\\u5b81\\u8499\\u4eac\\u6d25\\u8fbd\\u5409\\u9ed1\\u9752\\u9655\\u664b\\u8c6b\\u5180\\u9c81\\u7696\\u82cf\\u6d59\\u6caa\\u4e91\\u5ddd\\u6e1d\\u8d35\\u6842\\u743c\\u9102\\u6e58\\u8d63\\u95fd\\u7ca4\\u6fb3\\u6e2f\\u8b66][A-Za-z][0-9A-Za-z]{5,6}[\\u6302]?$';

    public validate(variable) {
        let ok = true;
        // console.log(['plate', variable, this.regex]);
        let objRegEx = new RegExp(this.regex);
        ok = objRegEx.test(variable);
        return ok;
    }

}
